<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M6 6L13.1783 13.1783M42 42L34.8224 34.8224M27.7497 37.6492C26.5354 37.8795 25.2822 38 24.0009 38C15.0456 38 7.46501 32.1142 4.9165 23.9999C5.6103 21.791 6.67702 19.7472 8.04287 17.9424M19.7574 19.7574C20.8431 18.6716 22.3431 18 24 18C27.3137 18 30 20.6863 30 24C30 25.6569 29.3284 27.1569 28.2426 28.2426M19.7574 19.7574L28.2426 28.2426M19.7574 19.7574L13.1783 13.1783M28.2426 28.2426L13.1783 13.1783M28.2426 28.2426L34.8224 34.8224M13.1783 13.1783C16.298 11.1671 20.0131 10 24.0009 10C32.9562 10 40.5368 15.8858 43.0853 24.0001C41.6715 28.5014 38.709 32.317 34.8224 34.8224"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
